import { render, staticRenderFns } from "./NewsDetail56.vue?vue&type=template&id=09f0e3a4&scoped=true"
import script from "./NewsDetail56.vue?vue&type=script&lang=js"
export * from "./NewsDetail56.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail56.vue?vue&type=style&index=0&id=09f0e3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0e3a4",
  null
  
)

export default component.exports